import React from 'react';

const BannerHeader = ({ title, subtitle }) => {
  if (!title && !subtitle) return null;

  return (
    <div className="form-header">
      {title && <h2>{title}</h2>}
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};

export default BannerHeader;
